import React from 'react';
import { createStyleSheet, useStyleSheet, Divider, View, Button } from '@gopeerproject/ui-kit';
import { Dropdown } from '../Dropdown';
import { CalendarDropdown } from '../CalendarDropdown';
export const DateRangeSelector = ({ list, mutable, dateRangeProps, direction }) => {
    const styles = useStyleSheet(getStyles);
    const { range, setRange, setCustomRange, from, to } = dateRangeProps;
    return (React.createElement(View, { style: styles.timeDropdownContainer },
        React.createElement(Dropdown, { trigger: ({ onPress, selected }) => {
                var _a;
                return (React.createElement(Button, { type: 'secondary', accent: 'neutral', onPress: onPress, size: 'md', text: (_a = selected === null || selected === void 0 ? void 0 : selected.label) !== null && _a !== void 0 ? _a : 'Choose Range', rightIcon: 'chevron-down' }));
            }, list: list, selected: range, setSelected: setRange, searchable: false }),
        React.createElement(Divider, { type: 'vertical', style: styles.smallDivider }),
        React.createElement(CalendarDropdown, { from: from, to: to, onChange: (v) => {
                setCustomRange({ from: v.from, to: v.to });
            }, mutable: mutable, direction: direction, hidden: true })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    timeDropdownContainer: {
        flexDirection: 'row',
        backgroundColor: color.invert2.p4,
        borderRadius: size.I,
        gap: size.B
    },
    smallDivider: { height: size.G, alignSelf: 'center' }
}));
//# sourceMappingURL=index.js.map